module.exports = __webpack_public_path__ + "assets/82c9cd0496c773a29b2b80273cf108a1.svg";